export class Option<T> {
    constructor(public label: string, public value: T) {
    }
}
